import { render, staticRenderFns } from "./usercourse.vue?vue&type=template&id=6b589ef6&scoped=true&"
import script from "./usercourse.vue?vue&type=script&lang=js&"
export * from "./usercourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b589ef6",
  null
  
)

export default component.exports